import React, { useEffect, useState } from "react";

const rub = (amount) => Number(amount) > 0 && Number(amount) < 0.000001 ? "< 0,000001 ₽" : new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 6 }).format(Number(amount)) + " ₽";

export function BetaBudget({ api }) {
  const [admission, setAdmission] = useState(null);
  const [budget, setBudget] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    const read = () => api.request("/v1/beta/budget").then((result) => { if (!cancelled) { setBudget(result.budget || null); setAdmission(result.admission); setError(""); } })
      .catch(() => { if (!cancelled) setError("Не удалось обновить пробный бюджет."); })
      .finally(() => { if (!cancelled) setLoading(false); });
    read();
    const timer = setInterval(read, 30000);
    return () => { cancelled = true; clearInterval(timer); };
  }, [api]);
  if (admission?.state === "pending") return <section className="surface beta-budget" aria-label="Заявка организации"><h3>Организация ожидает одобрения</h3><p>Администратор платформы назначит стартовый баланс и откроет доступ к запуску решений.</p>{error && <p role="alert">{error}</p>}</section>;
  if (!budget) return <section className="surface beta-budget" aria-label="Пробный бюджет"><h3>Пробный бюджет</h3>
    {error ? <p className="inline-problem" role="alert">{error}</p> : <p className="muted">{loading ? "Загружаем бюджет…" : "Пробный бюджет не назначен."}</p>}
  </section>;
  return <section className="surface beta-budget" aria-label="Пробный бюджет">
    <h3>Пробный бюджет{budget.expired ? " · срок завершён" : ""}</h3>
    <div className="form-grid">
      <div>Всего<strong>{rub(budget.limit)}</strong></div>
      <div>Учтено<strong>{rub(budget.known)}</strong></div>
      <div>Зарезервировано<strong>{rub(budget.held)}</strong></div>
      <div>Доступно<strong>{budget.expired ? "Срок завершён" : rub(budget.available)}</strong></div>
    </div>
    <p className="muted">До {new Date(budget.expiresAt).toLocaleDateString("ru-RU")}. Резерв включает выполняемые вызовы и вызовы с неизвестной стоимостью.</p>
    {budget.unknownAttempts > 0 && <p className="inline-warning">Не определена стоимость {budget.unknownAttempts} вызовов. Их резерв удерживается.</p>}
    {Number(budget.charged) !== Number(budget.known) && <p className="muted">Для ограничения расходов учтено {rub(budget.charged)}: эта консервативная сумма может превышать рассчитанную стоимость.</p>}
    {error && <p className="inline-problem" role="alert">{error}</p>}
  </section>;
}
